// extracted by mini-css-extract-plugin
module.exports = {"container":"HourglassSpinner_container__HqXVa","hourglass":"HourglassSpinner_hourglass__Mw6qm","rotation":"HourglassSpinner_rotation__vSs7v"};